import { ioExtend, ioGuid, QueryParams } from '@framework';

export class AddressModel {
    
    AddressID: string;
    AddressTownID: string;
    District: string;
    Town: string;
    AddressStreetID: string;
    Street: string;
    StreetLat: string = null;
    StreetLng: string = null;
    Number: string;
    PostCode: string;

    AddressNotes: string = null;
    AddressLat: string = null;
    AddressLng: string = null;

    isActive: boolean = null;

    constructor(_instance?: {}) {
        ioExtend(this, _instance);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }

}

export class AddressTown {
    AddressTownID: string;
    District: string;
    Town: string;

    constructor(_instance?: {}) {
        ioExtend(this, _instance);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }

}

export class AddressStreet {
    AddressStreetID: string = null;
    AddressTownID: string = null;
    Street: string = null;
    Number: string = null;
    PostCode: string = null;
    StreetLat: string = null;
    StreetLng: string = null;
   
    constructor(_instance?: {}) {
        ioExtend(this, _instance);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }

}
